module.exports = __webpack_public_path__ + "img/Eventos_registrar_asistentes.2975f933.svg";